<template>
<nav class="navigation">
  <button class="navi-btn open-navigation" aria-label="Odpri meni z navigacijo" data-string-close="Zapri navigacijo" data-string-open="Odpri navigacijo"
    @click.prevent="openMenu"
  >

    <span class="visuallyhidden">Odpri navigacijo</span>
  </button>
  <div :class="innerOpen()">
  <button aria-label="Zapri meni z navigacijo" type="button" class="close-navigation-btn close-popup-btn close-navigation" tabindex="-1"
  @click.prevent="closeMenu"
  >
    <span class="visuallyhidden">Zapri menu</span>
  </button>
    <div class="menus">

    <!-- dynamic menu-->
      <ul class="menu primary">
        <li>
          <a href="home"
            @click.prevent="updateMenu({name:'home',path:'/'})"
            :class="highlightSection({name:'home',path:'/'})"
          >
            <font-awesome-icon icon="home"/>
            Domov
          </a>
        </li>
       
    </ul>
    <!-- login status and info spacer + user name + nek info o prijavi/vlogi in odjava-->

    <ul v-if="!status.loggedIn" class="prijava menu">
       <li>
        <a href="/login/"
          @click.prevent="updateMenu({name:'login',path:'/login/'})"
          :class="highlightSection({name:'login',path:'/login/'})"
        >
         <font-awesome-icon icon="user"/>
          Prijava
        </a>
      </li>
     
    </ul>
    <ul v-else class="prijavljen menu">

      <li v-for="menuItem in menu">
      


             <a :href="menuItem.path"
          @click.prevent="updateMenu(menuItem)"
          :class="highlightSection('menuItem')"
        >
        <font-awesome-icon :icon="menuItem.icon"/>
         

          {{menuItem.text}}
        </a>
        
            <ul v-if="menuItem.submenu" class="submenu">
                <li v-for="submenuItem in menuItem.submenu">
                   <a :href="submenuItem.path"
                    @click.prevent="updateMenu(submenuItem)"
                    :class="highlightSection('submenuItem')"
                    >
                  <font-awesome-icon :icon="submenuItem.icon"/>
                  {{submenuItem.text}}
                  </a>
                </li>
            </ul>

      </li>
        
     
       
      
     
     <li class="uporabnik-spacer"></li>
   
     <li class="uporabnik ">{{userDetails.name}}</li>
     <li class="uporabnik">{{userDetails.vloga}}</li>
  <!--   <li class="uporabnik">Zadnja prijava:</li>
    {{menu.name}}
     <li class="uporabnik">19.5.2020 9:27</li> -->
    </ul>
    </div>
  </div>

</nav>



    <!-- root level items -->
   

    <!-- context menu: childs of root level items -->
    <!--
    <transition name="slide-fade">

      <div class="context-menu-container" v-show="showContextMenu">

        <ul class="context-menu">

          <li v-for="(item, index) in menuItems" :key="index">

            <h5 v-if="item.type === 'title'" class="context-menu__title">

              <i :class="item.icon" aria-hidden="true"></i>

              {{item.txt}}

              <a
              v-if="index === 0"
              @click.prevent="closeContextMenu"
              class="context-menu__btn-close"
              href="#"
              >
                <i class="fa fa-window-close" aria-hidden="true"></i>
              </a>

            </h5>

            <a
            v-else
            href="#"
            @click.prevent="openSection(item)"
            :class="subMenuClass(item.txt)"
            >
              {{item.txt}}
            </a>

          </li>

        </ul>

      </div>

    </transition>
  -->

  </div>

</template>

<script>
import menuData from './support/menu-data';
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Menu',

  data(){
    return {
      contextSection: '',

      menuItems: [],

      menuData: menuData,

      activeSubMenu: '',
      menuOpened: false,

    }
  },
  created() {
    if(localStorage.getItem('user')){
        console.log("cel menu ou apija");
      console.log(this.menu);
         this.getLoggedIn()
         .then(f=>this.getMenu())
         .then(f=>console.log(this.menu));
        
         

    }
      
        
  },
  methods: {

    openProjectLink() {
      alert('You could open the project frontend in another tab here, so the logged admin could see changes made to the project ;)');
    },

    updateMenu(item) {
      this.contextSection = item.name;
      //this.menuItems = this.menuData[context];

        this.menuOpened=false;
        this.$router.push({path: item.path});
        //window.bus.$emit('menu/closeMobileMenu');
      
    },

    highlightSection(section) {

      return {
        'link': true,
        'link-active': section === this.contextSection,
      };
    },
    innerOpen() {
      return {
        'inner': true,
        'navi-is-open': this.menuOpened,
      };
    },
    openMenu() {
      this.menuOpened=true;
      },
    closeMenu() {
      this.menuOpened=false;
      },

    ...mapActions('users', ['getLoggedIn','getMenu']),

  },

  computed: {
    showContextMenu() {
      return this.menuItems.length;
    },
    ...mapState('account', ['status']),
    ...mapState('users', ['userDetails','menu'])
  }

}
</script>
